import { stringify } from "querystring";
import OrderSchema from "schemas/orders/order";

type IQueryOptions = {
    populate?: string[];
};

export const getCartQuery = (brandId: string, options: IQueryOptions) => {
    const query = {
        __populate: options?.populate ?? [],
    };
    return {
        force: true,
        schema: OrderSchema,
        options: {
            method: "GET",
        },
        url: `/brand/${brandId}/cart?${stringify(query)}`,
    };
};

export const getCartPricingQuery = (brandId: string, options: IQueryOptions) => {
    const query = {
        __populate: options?.populate ?? [],
    };
    return {
        force: true,
        schema: OrderSchema,
        options: {
            method: "GET",
        },
        url: `/brand/${brandId}/cart/pricing?${stringify(query)}`,
    };
};
